import(/* webpackMode: "eager", webpackExports: ["HomePrototypeLayout"] */ "/vercel/path0/apps/getxobelaeskola-web/src/components/home-prototypes/HomePrototypeLayout.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/shared/NativeAppRedirect.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
